import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Pannellum } from "pannellum-react";
import { collection, getDocs } from "firebase/firestore";

import { db } from '../firebase';

const weatherMap = {
  '1': 'cloudy',
  '2': 'rainy',
  '3': 'snowy',
  '4': 'windy',
  '5': 'clear',
  '0': 'none'
}

const Image360 = ({ contract, weatherContract }) => {
  const { id } = useParams();
  const imageCollectionRef = collection(db, "images");

  const [image360, setImage360] = useState({});
  const [position, setPosition] = useState({})
  const [weatherCondition, setWeatherCondition] = useState('')

  useEffect(() => {
    getImage();
  }, [])
  
  const getImage = async () => {
    const data = await getDocs(imageCollectionRef);

    const images = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    const image = images.filter(i => i.id === id);
    console.log(image[0].location);
    const [latitude, longtitude] = image[0].location
    setPosition({
      latitude,
      longtitude
    })
    setImage360(image[0]);
  }

  const updateWeather = async () => {
    const { longtitude, latitude } = position
    const backendUrl = `https://silly-goofy-eclipse.glitch.me/weather?longtitude=${longtitude}&latitude=${latitude}`
    const tx = await weatherContract.requestweatherData(backendUrl)
    console.log(tx)
    const weatherCondition = await weatherContract.weather()
    let weather = weatherCondition.div('1000000000000000000').toString()
    console.log('weather condition', weather)
    setWeatherCondition(weather)
  }

  const mintNft = async () => {
    const { longtitude, latitude } = position
    const long = parseInt(Math.abs(longtitude))
    const lat = parseInt(Math.abs(latitude))
    console.log(58, long, lat)
    const transaction = await contract.mint(long, lat, weatherCondition);
    const tx = await transaction.wait();
    console.log(tx);
  }

  return (
    <div className='container'>
      <div className='d-flex justify-content-between'>
        <h1>{image360.name}</h1>
        <h3 style={{paddingTop: 10}}>{weatherMap[weatherCondition]}</h3>
        {
          weatherCondition ? <button className='btn btn-primary' onClick={mintNft}>
                              Mint as NFT
                            </button> :
                            <button className='btn btn-primary' onClick={updateWeather}>
                              Get Weather
                            </button>  
        }
      </div>
      <Pannellum
        width="100%"
        height="500px"
        image={image360.url}
        pitch={10}
        yaw={180}
        hfov={110}
        autoLoad
        showZoomCtrl={false}
      >
          <Pannellum.Hotspot
            type="custom"
            pitch={12.41}
            yaw={117.76}
            handleClick={(evt, name) => console.log(name)}
            name="image info"
          />
      </Pannellum>
    </div>
  )
}

export default Image360;